<template>
  <div>
    <v-card-text>{{ approvalInstructions }}</v-card-text>
    <v-row class="ma-0 pl-4">
      <v-select
        id="revision-dialog-approval-select"
        outlined
        label="Approval Status"
        :items="items"
        v-model="paper.state.status"
        dense
      />
    </v-row>
    <v-row class="ma-0" justify="end">
      <v-btn :loading="loading" @click="submit()" class="success" id="revision-dialog-submit-button">
        submit feedback
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import paper from "@/helpers/paperStatus.js";

export default {
  props: ["paper"],
  data() {
    return {
      approvalInstructions:
        "Write here the approval instructions. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam tincidunt orci id posuere pellentesque. Morbi eget lacus et ante euismod ornare. Sed tincidunt volutpat nunc scelerisque iaculis. Nam convallis eu leo id gravida. Suspendisse dapibus ex vitae consequat mattis. Mauris consectetur porttitor magna, quis suscipit sem varius et. Curabitur molestie orci vel consectetur aliquam. Nulla eu bibendum libero, vel fringilla purus. ",
      items: [
        "Accepted",
        "Rejected",
        "Accepted with Revision",
        "More Reviews",
        "Rejected with Revision",
        "Unassigned",
        "Under Review",
      ],
      loading: false,
    };
  },
  methods: {
    async sendLogs() {
      this.$store.dispatch("updateChangeLogs", {
        paperId: this.paper.id,
        log: {
          label: `${paper.changeLog("", "")["trackReview"].label}`,
          datetime: new Date().toLocaleString("en-US"),
        },
      });
      this.$store.dispatch("updateChangeLogs", {
        paperId: this.paper.id,
        log: {
          label: `${paper.changeLog(this.paper.state.status, "")["statusChanged"].label}`,
          datetime: new Date().toLocaleString("en-US"),
        },
      });
      if(paper.needsReupload(this.paper.state.status)){
         this.$store.dispatch("updateChangeLogs", {
        paperId: this.paper.id,
        log: {
          label: `${paper.changeLog("", "")["needsReupload"].label}`,
          datetime: new Date().toLocaleString("en-US"),
        },
      });
      }
    },
    async submit() {
      //create newPaper object without paper id
      this.loading = true;

      let newPaper = {};
      Object.assign(
        {},
        Object.keys(this.paper).forEach((key) => {
          if (key !== "id") newPaper[key] = this.paper[key];
        })
      );

      //update lastUpdated
      newPaper.lastUpdate = new Date().toLocaleString("en-US");

      //update paper
      await this.$store
        .dispatch("updatePaper", {
          id: this.paper.id,
          data: newPaper,
        })
        .then(() => {
          this.sendLogs()
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Feedback submitted succesfully!",
            color: "success",
          });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Oops... Error updating approval status",
            color: "error",
          });
          console.error("Error updating approval status ", err);
        });

      this.loading = false;
    },
  },
};
</script>